import { ContentSection, Main } from "@vwfs-bronson/bronson-react";
import { WizardNavigation } from "./WizardNavigation";
import { WizardPageProps } from "@product-pages/common/types";
import PageHeader from "@components/common/PageHeader";
import PageFooter from "@components/common/PageFooter";
import { SkipLink } from "@components/common";

interface Props {
  page: React.ReactElement<WizardPageProps>;
  wizardPages?: React.ReactElement<WizardPageProps>[];
  currentStepIndex: number;
  firstStepPath: string;
  noFunctionalSteps: { title: string }[];
}

export const WizardPage = ({
  page,
  currentStepIndex,
  noFunctionalSteps,
}: Props) => {
  return (
    <>
      <SkipLink id="main" />
      <PageHeader documentTitle={`${page.props.title}`} />

      <Main id="main">
        <WizardNavigation
          currentStepTitle={page.props.title}
          noFunctionalSteps={noFunctionalSteps}
          currentStepIndex={currentStepIndex}
        />
        <ContentSection pageWrapSize={page.props.pageWrapSize ?? "small"}>
          <ContentSection className="u-pt u-pb">{page}</ContentSection>
        </ContentSection>
      </Main>
      <PageFooter />
    </>
  );
};
